import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import MyEditor from '../../cpn/MyEditor';
import { useBnsXuQiuUpdateQuery, useBnsXuQiuUpdateSaveMutation } from '../../store/BnsKeJiApi';
import ModuleSelect from '../../backend/module/ModuleSelect';
function RequireEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState(); 
    const {data,isSuccess} = useBnsXuQiuUpdateQuery({bxq_id:props.bxq_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bxq_name:data.Result.bxq_name,
                    bxq_content:data.Result.bxq_content,
                    bxq_dept_id:data.Result.bxq_dept_id,
                    bxq_bg_id:data.Result.bxq_bg_id,
                    "bxq_bgn_id" : data.Result.bxq_bgn_name,
                })
                setInfo(prevState=>({...prevState,
                    bxq_name:data.Result.bxq_name,          
                    bxq_content:data.Result.bxq_content,
                    bxq_dept_id:data.Result.bxq_dept_id,        
                    bxq_dept_name:data.Result.bxq_dept_name,        
                    bxq_bg_id:data.Result.bxq_bg_id,        
                    bxq_bg_name:data.Result.bxq_bg_name,  
                    "bxq_bgn_id" : data.Result.bxq_bgn_id,
                    "bxq_bgn_name" : data.Result.bxq_bgn_name,      
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsXuQiuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改需求'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bxq_content" : info.bxq_content,
                        "bxq_dept_id" : info.bxq_dept_id,
                        "bxq_dept_name" : info.bxq_dept_name,
                        "bxq_bg_id" : info.bxq_bg_id,
                        "bxq_bg_name" : info.bxq_bg_name,
                        "bxq_e_id" : localStorage.getItem('e_id'),
                        "bxq_id" : props.bxq_id,
                        "bxq_name" : info.bxq_name,
                        "bxq_uid" : localStorage.getItem('eu_id'),
                        "bxq_uname" : localStorage.getItem('eu_name'),   
                        "bxq_bgn_id" : info.bxq_bgn_id,
                        "bxq_bgn_name" : info.bxq_bgn_name,                            
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <ModuleSelect
                        nameProduct='bxq_bg_id'
                        nameVersion='bxq_bgn_id'
                        label='版本'
                        required
                        onChangeProduct={(e,f,g,h) => {
                            setInfo(prevState=>({
                                ...prevState,
                                bxq_bg_id:e,
                                bxq_bg_name:f,
                                "bxq_dept_id" : g,
                                "bxq_dept_name" : h,
                            }))
                        }}
                        onChangeVersion={(e,f) => {
                            setInfo(prevState=>({
                                ...prevState,
                                bxq_bgn_id:e,
                                bxq_bgn_name:f.label
                            }))
                        }}
                    />  
                    <Form.Item 
                        name="bxq_name" 
                        label='标题' 
                        wrapperCol={{span:20}} 
                        required
                    >
                        <Input 
                             onChange={(e) => {setInfo(prevState=>({...prevState,bxq_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item 
                        name="bxq_content" 
                        label='正文' 
                        wrapperCol={{span:20}} 
                    >
                        <MyEditor 
                             onChange={(e) => {setInfo(prevState=>({...prevState,bxq_content:e}))}}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default RequireEdit